import React from 'react';
import styled from '@emotion/styled';
import TouchedWrapper from '~Scenes/SelfServiceKiosks/Components/TouchedWrapper';
import { LocalItem } from '~Types';
import Item from './Item';
import { useI18n } from '~Hooks';

const Container = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;

  transition: transform 0.35s, background-color 0.35s 0.25s, opacity 0.35s;
  transform: translateY(${({ visible }) => (visible ? 0 : 100)}vh);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background-color: rgba(0, 0, 0, ${({ visible }) => (visible ? 0.5 : 0)});
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 50%;
  padding: 40px;
  border-radius: 40px;
  background: rgb(255, 255, 255);
  position: relative;

  @media (orientation: landscape) {
    width: 30%;
  }
`;

const Title = styled.div`
  color: rgb(19, 19, 22);
  font-size: 24px;
`;

const Items = styled.div`
  max-height: 1000px;
  overflow: auto;

  @media (orientation: landscape) {
    max-height: 510px;
  }
`;

const Button = styled(TouchedWrapper)`
  height: 100px;
  box-sizing: border-box;
  padding: 0 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(19, 19, 22);
  border-radius: 16px;
`;

const ButtonLabel = styled.div`
  color: rgb(255, 255, 255);
  font-size: 28px;
  line-height: 56px;
`;

type Props = {
  visible: boolean;
  items: LocalItem[];
  onClose: () => void;
};
const OutOfStockAlert = ({ visible, items, onClose }: Props) => {
  const { i18n } = useI18n();

  return (
    <Container visible={visible}>
      <Wrapper>
        <Title>{i18n('SSK.Checkout.OutOfStock.Title')}</Title>
        <Items>
          {items.map((item, index) => (
            <Item key={item.itemId + index} item={item} last={index === items.length - 1} />
          ))}
        </Items>
        <Button onClick={onClose}>
          <ButtonLabel>{i18n('SSK.Close')}</ButtonLabel>
        </Button>
      </Wrapper>
    </Container>
  );
};

export default OutOfStockAlert;
